import { FormInstance } from "antd";
import { CoverWizardForm } from "./CoverWizardModal";

export function poolOwnerInfoPageContainsEmptyFields(
  form: FormInstance<CoverWizardForm>
) {
  const formData: CoverWizardForm = form.getFieldsValue(true);
  return (
    (!formData.poNumber && !formData.jobName) ||
    !formData.address ||
    !formData.city ||
    !formData.stateCode ||
    !formData.zip
  );
}
